<template>
    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="95" label-position="right"
                                  :loading="loading" ref="form">
                                <!--<FormItem :label="t.menu.catalog" prop="division">-->
                                <FormItem :label="t.menu.catalog" prop="division">
                                    <Select v-model.trim="formItem.division" @on-change="handleChangeDivision($event)"
                                            :placeholder="msgUtil.placeholderSelected(t.menu.catalog)">
                                        <Option :value="item.division" :key="item.division"
                                                v-for="item in divisionList">
                                            {{item.name}}
                                        </Option>
                                    </Select>
                                </FormItem>
                                <FormItem :label="t.menu.type" prop="type">
                                    <RadioGroup v-model.trim="formItem.type" type="button" size="small"
                                                @on-change="handleChangeType">
                                        <Radio :label="item.type" :key="item.type" v-for="item in typeList">
                                            {{item.name}}
                                        </Radio>
                                    </RadioGroup>
                                </FormItem>
                                <transition name="fade" mode="out-in">
                                    <!--<FormItem v-if="parentFlg" :label="t.menu.parentName" prop="parentName">-->
                                    <FormItem v-if="parentFlg" :label="t.menu.parentName">
                                        <Input v-model.trim="formItem.parentName"
                                               :placeholder="msgUtil.placeholderRequired(t.menu.parentName)"
                                               readonly>
                                            <Button slot="append" @click="openTreeModal">
                                                {{t.menu.selected}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                </transition>
                                <FormItem :label="nameChange" prop="name">
                                    <Input v-model.trim="formItem.name" :maxlength="10"
                                           :placeholder="msgUtil.placeholderRequired(t.menu.menuName)"></Input>
                                </FormItem>
                                <FormItem :label="t.menu.icon" prop="icon">
                                    <AutoComplete
                                        v-model.trim="formItem.icon"
                                        :icon="formItem.icon"
                                        :placeholder="msgUtil.placeholderSelected(t.menu.icon)"
                                        style="width:200px" ref="autoCom">
                                        <div style="height:200px;width:200px">
                                            <Icon style="cursor: pointer;padding: 4px 4px;" :value="item" :key="item"
                                                  v-for="item in msgUtil.iconList" :label="item"
                                                  :type="item" size="20"
                                                  @click.native="handleClickIcon(item)"/>
                                        </div>
                                    </AutoComplete>
                                </FormItem>
                                <FormItem :label="t.menu.url" prop="url">
                                    <Input v-model.trim="formItem.url" :maxlength="100"
                                           :placeholder="msgUtil.placeholderRequired(t.menu.url)"></Input>
                                </FormItem>
                                <FormItem :label="t.menu.permit" prop="permit">
                                    <Input v-model.trim="formItem.permit" :maxlength="100"
                                           :placeholder="msgUtil.placeholderRequired(t.menu.permit)"></Input>
                                </FormItem>
                                <FormItem :label="t.menu.sortOrder" prop="sortOrder">
                                    <InputNumber v-model.trim="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.menu.status" prop="status">
                                    <i-switch v-model.trim="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.menu.statusOpen}}</span>
                                        <span slot="close">{{t.menu.statusClose}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading"
                                            @click="handleAddSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()"
                                            style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Modal
            :title='msgUtil.message.action.add'
            v-model.trim="treeNode.modal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false">
            <Row>
                <Col style="padding-left:20px;height: 300px;overflow-x: auto;">
                    <!--<Tree :data="nodeList" :render="renderContent" @on-selected="selectTreeNode" />-->
                    <Tree ref="tree" :data="nodeList"/>
                </Col>
            </Row>
            <Row>
                <Col style="padding-left:20px;" span="14">
                    <Alert v-if="treeNode.error" style="padding: 6px 48px 6px 38px;" type="error" show-icon>
                        {{msgUtil.placeholderSelected(t.menu.parentName)}}
                    </Alert>
                </Col>
                <Col style="text-align:right;">
                    <Button type="primary" @click="handleSubmitTreeNode">
                        {{msgUtil.message.action.submit}}
                    </Button>
                </Col>
            </Row>
        </Modal>
    </div>
</template>
<script>
import { add, getSubTreeMenuList } from '@/api/menu';
import ZkTable from '@/components/Table/Table';

export default {
    name: 'organization_menu_add',
    components: {
        ZkTable,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                method: 'GET',
                parentId: '',
                name: '',
                icon: '',
                url: '',
                permit: '',
                sortOrder: 0,
                type: '',
                status: '1',
                division: '',
                parentName: '',
            },
            treeNode: {
                modal: false,
                error: false,
            },
            divisionList: [{ name: t.menu.frontEndName, division: '1' }, { name: t.menu.backEndName, division: '2' }],
            typeList: [{ name: t.menu.typeMenu, type: 'm' }, { name: t.menu.typeButton, type: 'b' }],
            nodeList: [],
            parentFlg: false,
            ruleValidate: {
                division: [
                    {
                        required: true,
                        message: msgUtil.errorSelected(t.menu.catalog),
                        trigger: 'change',
                    },
                ],
                type: [
                    {
                        required: true,
                        message: msgUtil.errorSelected(t.menu.type),
                        trigger: 'change',
                    },
                ],
                parentName: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.parentName),
                        trigger: 'change',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.menuName),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 20,
                        message: msgUtil.errorMaxLength(t.menu.menuName, 20),
                        trigger: 'blur',
                    },
                ],
                icon: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.icon),
                        trigger: 'change',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.menu.icon, 100),
                        trigger: 'blur',
                    },
                ],
                url: [
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.menu.url, 100),
                        trigger: 'blur',
                    },
                ],
                permit: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.menu.permit),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.menu.permit, 100),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
        };
    },
    computed: {
        nameChange() {
            if (this.formItem.type === 'b') {
                return this.t.menu.buttonName;
            }
            return this.t.menu.menuName;
        },
    },
    methods: {
        async treeMenuListSetting() {
            //得到后台所有菜单展示
            const treeMenuList = await getSubTreeMenuList({
                division: this.formItem.division,
                type: this.formItem.type,
            });
            this.nodeList = treeMenuList.menus;
        },
        async handleChangeDivision(val) {
            //类型选择的场合，动态刷新类型下拉列表。
            if (this.formItem.type === '') {
                return;
            }
            this.formItem.division = val;
            this.parentFlg = true;
        },
        async handleChangeType() {
            this. formItem.parentName = "";
            if (this.formItem.division === '') {
                return;
            }
            this.parentFlg = true;
        },
        handleClickIcon(val) {
            //this.$refs.autoCom.$children[0].onOptionClick({value:val,label:val});
            this.formItem.icon = val;
        },
        handleAddSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    this.loading = true;
                    const menuDto = Object.assign({}, this.formItem);
                    delete menuDto.parentName;
                    const res = await add(menuDto);
                    this.nodeList = [];
                    this.handleReset();
                    this.$Loading.finish();
                    this.$Message.success(this.msgUtil.message.action.addSuccess);
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.addFail);
                }
            });
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            this.loading = false;
            this.nodeList = [];
            this.parentFlg = false;
        },
        async openTreeModal() {
            await this.treeMenuListSetting();
            this.treeNode.error = false;
            this.treeNode.modal = true;
        },
        handleSubmitTreeNode() {
            let choicesAll = this.$refs.tree.getSelectedNodes(); //方法的运用 getSelectedNodes也是如此用法
            if (choicesAll.length === 0) {
                this.treeNode.error = true;
                return;
            }
            this.formItem.parentId = choicesAll[0].id;
            this.formItem.parentName = choicesAll[0].name;
            this.treeNode.modal = false;
            this.treeNode.error = false;
            this.parentFlg = true;
        },
        /*renderContent(h, { root, node, data }) {
                                                return h(
                                                    'span',
                                                    {
                                                        /!*style: {
                                                                        display: 'inline-block',
                                                                        width: '100%',
                                                                        margin:'0',
                                                                        padding: '0',
                                                                    },
                                                                    class: 'ivu-select-item',*!/
                                                        on: {
                                                            click: () => {
                                                                console.log('sssssssssssss');
                                                                /!*this.$refs.selection.onClickOutside(event);
                                                                            this.$refs.selection.onOptionClick({value:data.id,label:data.name});
                                
                                                                            this.formItem.parentId = data.id;
                                                                            this.$refs.selection.checkUpdateStatus();*!/
                                                            },
                                                        },
                                                    },
                                                    data.name
                                                );
                                            },*/
    },
    async mounted() {},
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
